import { Box } from '@material-ui/core';
import React from 'react';

import { ReactComponent as CommentIcon } from '../../../shared/assets/icons/comment.svg';
import { ReactComponent as GlassesIcon } from '../../../shared/assets/icons/glasses.svg';
import { ReactComponent as LightningIcon } from '../../../shared/assets/icons/lightning.svg';
import { toTzMoment } from '../../../shared/lib';
import { getReservePersonName, getReserveItemState, tableColors } from '../lib';
import { lightTheme } from '../lib/theme';
import { ReserveFooterWidget } from './reserveFooter';
import { SvgIcon } from './svgIcon';
import { Tag } from './tag';

const { fg } = lightTheme;

export const ReserveWidget = ({
  scheduleReserve,
  onExpand,
  // isTableView,
  tablesSchedule,
  restaurantTz,
  // compact = false,
}: {
  scheduleReserve: GM.ReservesSchemas.ScheduleReserve;
  onExpand: () => void;
  // isTableView: boolean;
  tablesSchedule: GM.ReservesSchemas.TablesSchedule;
  restaurantTz?: string;
  // compact?: boolean;
}) => {
  const person = getReservePersonName(scheduleReserve);
  const date = toTzMoment(scheduleReserve.date, restaurantTz);
  const timeStr = date.format('HH:mm');
  const state = getReserveItemState(
    scheduleReserve,
    tablesSchedule[scheduleReserve.tables[0].id],
    restaurantTz,
  );

  const isWarningMessage = ['WARNING', 'CONFLICT'].includes(state);
  const isPrepay = !!scheduleReserve.prepay?.amount;

  const renderPrepayTag = () => {
    if (!isPrepay) {
      return null;
    }

    const isPaid = scheduleReserve.state !== 'AWAIT_PREPAY';

    const stateColorName = !isPaid && !isWarningMessage ? 'WARNING' : state;
    const tagStyles: React.CSSProperties = {
      color: tableColors[stateColorName].head.color,
      background: tableColors[stateColorName].head.bg,
    };

    if (tableColors[stateColorName].head.stripe) {
      tagStyles['background'] = `repeating-linear-gradient(
            -45deg,
            ${tableColors[stateColorName].head.stripe} 0 4px,
            transparent 4px 8px
          ), ${tagStyles.background}`;
    }

    return (
      <Tag style={{ ...tagStyles, padding: '2px 9px' }}>
        Депозит
        {isPaid ? ' ' : ' не '}
        оплачен: {scheduleReserve.prepay.amount} ₽
      </Tag>
    );
  };

  return (
    <Box onClick={() => onExpand()}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mb={isWarningMessage || scheduleReserve.prepay?.amount ? '4px' : '8px'}
      >
        <Box>
          <Tag
            style={{
              color: tableColors[state].head.color,
              background: tableColors[state].head.bg,
              padding: '2px 9px',
            }}
          >
            <span style={{ fontWeight: 600 }}>{timeStr}</span>{' '}
            <span style={{ fontWeight: 400 }}>{date.format('DD.MM')}</span>
          </Tag>
        </Box>

        {(scheduleReserve.comment ||
          scheduleReserve.isBanquet ||
          scheduleReserve.isAutoBooking) && (
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            gridGap={8}
            color={fg.default}
          >
            {scheduleReserve.comment && (
              <Box display="flex">
                <SvgIcon icon={CommentIcon} width={14} height={14} />
              </Box>
            )}
            {scheduleReserve.isBanquet && (
              <Box display="flex">
                <SvgIcon icon={GlassesIcon} width={14} height={14} />
              </Box>
            )}
            {scheduleReserve.isAutoBooking && (
              <Box display="flex">
                <SvgIcon icon={LightningIcon} width={10} height={14} />
              </Box>
            )}
          </Box>
        )}
      </Box>

      {isPrepay && <Box mb={isWarningMessage ? '4px' : '8px'}>{renderPrepayTag()}</Box>}

      {isWarningMessage && (
        <Box
          mb="8px"
          color={tableColors[state].head.color}
          bgcolor={tableColors[state].head.bg}
          borderRadius={8}
          padding="8px 12px"
          fontSize={14}
        >
          {state === 'WARNING' && <>На этот стол скоро должен прийти гость</>}
          {state === 'CONFLICT' && (
            <>Время резерва наступило, но&nbsp;за&nbsp;столом сидят другие гости</>
          )}
        </Box>
      )}

      {person && (
        <Box fontSize={16} fontWeight={600} color={fg.default} style={{ lineHeight: 1.3 }}>
          {person}
        </Box>
      )}

      <ReserveFooterWidget
        room={scheduleReserve.tables[0].hall}
        tables={scheduleReserve.tables.map((t) => t.number)}
        persons={scheduleReserve.persons}
        collapsed
        onClickCollapse={(nextCollapsed) => {
          if (nextCollapsed) {
            onExpand();
          }
        }}
        // compact={compact}
        // isTableView={isTableView}
      />
    </Box>
  );
};
